import { MemberType } from '../models/unified-member.model';

/**
 * Returns true when the member row represents the currently logged-in user.
 * Works with any API shape — accepts whichever field names are available.
 */
export function isSelfMember(
  memberType: MemberType | undefined,
  memberableId: number | undefined,
  currentUserId: number | undefined
): boolean {
  return (
    currentUserId !== undefined &&
    (memberType ?? MemberType.User) === MemberType.User &&
    memberableId === currentUserId
  );
}
